export const FETCH_CURRENT_USER = 'FETCH_CURRENT_USER'
export const SHOW_NOTIFICATION = 'SHOW_NOTIFICATION'